if ($("#new-penalties").length > 0) {

if(window.innerWidth <= 576) {
    
    function changeModalBackdrop(e) {
        document.body.classList.add('custom-modal')
    }

    function checkAnswer(e) {

        var frameId = e.target.dataset.parent
        var answerId = document.getElementById(frameId).dataset.index

        if(e.target.hasAttribute('data-index')) {
        
            var optionId = e.target.dataset.index

            if(optionId == answerId) {
                var correctMessage = document.querySelector(`[data-index="${answerId}"]`)
                correctMessage.classList.remove('d-none')
                $(e.target).parent().find('.penalties-icons').show();
                var wrongMessage = document.querySelector(`.wrong[data-index="${answerId}"]`)
                wrongMessage.classList.add('d-none')
                var fullframe = document.querySelector(`.full-frame[data-index="${answerId}"]`)
                fullframe.classList.remove('d-none')
            }
        }

        else {
            var wrongMessage = document.querySelector(`.wrong[data-index="${answerId}"]`)
            wrongMessage.classList.remove('d-none')
            $(e.target).parent().find('.penalties-icons').show();
        }
    }
}

if(window.innerWidth > 576) {

  function allowDrop(ev) {
    ev.preventDefault();
  }
  
  function drag(ev) {
    ev.dataTransfer.setData("text", ev.target.id);
  }
  
  function drop(ev) {
  
    ev.preventDefault();
    var data = ev.dataTransfer.getData("text");
    var answer = document.getElementById(data)
    var answerId = ev.target.dataset.index
  
      if(answer.dataset.index == answerId) {
          ev.target.parentNode.insertBefore(answer, ev.target.nextSibling);
          answer.classList.add("correct-fine")
          console.log(answerId);
          var correctMessage = document.querySelector(`[data-index="${answerId}"]`)
          correctMessage.classList.remove('d-none')
          var wrongMessage = document.querySelector(`.wrong[data-index="${answerId}"]`)
          wrongMessage.classList.add('d-none')
  
          var allAnswers = document.querySelectorAll('.correct.d-none')
          
          if(allAnswers.length == 0) {
              document.querySelector('.penalties-answers-desktop h4').classList.remove("d-none")
              document.querySelector('.penalties-answers-desktop').classList.add("center-message")
              
          }
          
  
      }
  
      else {
          var wrongMessage = document.querySelector(`.wrong[data-index="${answerId}"]`)
          wrongMessage.classList.remove('d-none')
      }
  
  
  }
}

// var available;
// var percentage_of_page;
// var half_screen;
// var height;

// $(window).scroll(function (e) {
//     available = $(document).height();
//     percentage_of_page = 0.3;
//     half_screen = available * percentage_of_page;
//     height = $(window).scrollTop();
//     if(localStorage.getItem('popUpShown') == null) {
//         if(window.innerWidth > 576) {
//             if ( height > half_screen ) {
//                 $('.penalties-popup').addClass("show")
//                 $('#popDesktop').addClass("show")
//             }
//         }
//         else if(window.innerWidth <= 576) {
//             if ( height > half_screen ) {
//                 $('.penalties-popup').addClass("show")
//                 $('#popMobile').addClass("show")
//             } 
//         }
//     }

// });


// $('.penalties-popup.mobile button.close').on('click', () => {
//         $('.penalties-popup').removeClass("show")
//         $('#popMobile').removeClass("show")
//         $('#popMobile').height(0)
//         $('.penalties-popup.mobile').hide()
//         localStorage.setItem('popUpShown', 1)
// })

// $('.penalties-popup.desktop button.close').on('click', () => {
//         $('.penalties-popup.desktop').removeClass("show")
//         $('#popDesktop').removeClass("show")
//         $('#popDesktop').height(0)
//         $('.penalties-popup.desktop').hide()
//         localStorage.setItem('popUpShown', 2)
// })

// // changing the subheading size for penalties campaing landing page

// var penaltiesSubheading = $('.page_header_section .penalties-subheading')

// if(penaltiesSubheading) {
//     penaltiesSubheading.addClass('h2')
// }

}
